export default __webpack_public_path__ + "static/media/propsicon3.3e6d0781.svg";